import {Modal} from "react-bootstrap";

import {Button} from "@/components/button/Button.tsx";

interface CheckUnsavedModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  body?: string;
  confirmText?: string;
}

export const CheckUnsavedModal = ({show, onCancel, onConfirm, title, body, confirmText}: CheckUnsavedModalProps) => {
  return (
    <Modal show={show} centered onHide={onCancel}>
      <Modal.Header closeButton className="border-0">
        <div className="pulseTextH2Bold">{title || "You have unsaved changes"}</div>
      </Modal.Header>
      <Modal.Body className="pulseTextBody">{body || "Are you sure you want to discard your changes?"}</Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="secondary" onClick={onCancel}>
          Keep Editing
        </Button>
        <Button onClick={onConfirm}>{confirmText || "Discard"}</Button>
      </Modal.Footer>
    </Modal>
  );
};
